import { TimeFactorDto } from './time-factor.dto';

/***
 * https://difhub.com/view/organizations/Business%20Systems/systems/Settlement/applications/Billing/datasets/TimeSpec/versions/1
 */
export class TimeSpecDto {
  id?: string;
  expression: string;
  month: string | null; // enum from api
  week: string | null; // enum from api
  day: string | null; // enum from api
  weekDay: string | null; // enum from api
  hour: string | null; // enum from api
  minute: string | null; // enum from api
  factors: TimeFactorDto[] = [];

  constructor(d?: TimeSpecDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.month = d.month;
    this.week = d.week;
    this.day = d.day;
    this.weekDay = d.weekDay;
    this.hour = d.hour;
    this.minute = d.minute;
    this.expression = d.expression;

    if (d.factors) {
      this.factors = d.factors.map(f => new TimeFactorDto(f));
    }
  }
}
